import React from 'react';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useEmployeeService } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import ContactInfoContent from '../shared/ContactInfoContent';
import getContactInfoValidationSchema from '../createupdate/contactInfoValidationSchema';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import Prepopulation from 'domain/people/employee/prepopulation/Prepopulation';

const EmployeeContactInfoSummary: React.FC = () => {
  const { updateContactInfo, getForUpdate } = useEmployeeService();
  const employeeId = useEmployeeId();
  const { addMessage } = useMessageService('employeeContactInfo');

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
  };

  if (!employeeId) return null;

  const handleSubmit = (values: FormFieldsData) => {
    return updateContactInfo(employeeId, values);
  };

  return (
    <FormShowTemplate
      getDataFunc={() => getForUpdate(employeeId)}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getContactInfoValidationSchema}
      messageContext="employeeContactInfo"
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <Prepopulation>
        <ContactInfoContent />
      </Prepopulation>
    </FormShowTemplate>
  );
};

export default EmployeeContactInfoSummary;
